import React, { Component, PropTypes } from 'react';
import { closeStepsDepositflow, confDepositBonusNp as conf } from './../payment/common/lib/utils/router-config.js';
import navDeposit from './../payment/navdeposit/index.js';
import bonus from './../payment/bonus/index.js';
import scrollPosition from './../utils/scroll-position.js';

class DepositBonusNP extends Component {
	componentWillMount() {
		const { push } = this.props.history;

		// navDeposit.preparePaymentFormDataService();
		/* close any previously opened modules */
		closeStepsDepositflow({
			bonus: false,
			pendingwithdrawals: true,
			payment: true,
			depositResult: true
		});
		navDeposit.init(conf);
		bonus.init({
			wrapElmSelector: '#js-deposit-bonus',
			url: null, // (referrer === 'register' ? 'allBonusesUrl' : null),
			textkeys: conf.textkeys.selector,
			isEmptyCallback() {
				/* If no pending withdrawals exist, the step shall be skipped.
				When this is done the bonus-page is shown, and
				the backbutton must be updated  to close the flow or
				not go back to pending withdrawals, which creates a looping back button.*/
				push('/account/deposit/paymentnpnb');
			},
			confirmCallback() {
				/* If a bonus is selected the 'continue'-button will be shown, and then the next step is entered. .*/
				push('/account/deposit/paymentnp');
			}
		});
	}

	componentWillUnmount() {
		scrollPosition.save('deposit-bonus', document.querySelector('.js-deposit-bonus'));

	}

	render() {
		return (
			<div id="deposit-bonus-np" />
		);
	}
}

DepositBonusNP.propTypes = {
	history: PropTypes.object
};

export default DepositBonusNP;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-bonus-np.js